import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';

const Styles = labelStyles("TableCaption", {
  root: css`
    display: table-caption;
    &:not([data-show]) {
      position: absolute;
      height: 1px;
      width: 1px;
      overflow: hidden;
      clip: rect(1px, 1px, 1px, 1px);
    }
  `
});
const TableCaption = ({ children, show = false }) => {
  return jsx("caption", { css: Styles.root, "data-show": show ? "" : void 0, "data-zds": true }, children);
};

export { TableCaption };
//# sourceMappingURL=TableCaption.es.js.map
